import "./MultiverseOfMixupsShell.css";
import React, { Fragment } from "react";

export function MultiverseOfMixupsShell(props: {
  top: string;
  left: string;
  right: string;
  bottom: string;
  children: React.ReactNode;
}) {
  if (props.top.length !== 14) throw new Error("top has wrong length");
  if (props.left.length !== 12) throw new Error("left has wrong length");
  if (props.right.length !== 12) throw new Error("right has wrong length");
  if (props.bottom.length !== 14) throw new Error("bottom has wrong length");

  return (
    <div className="multiverse-of-mixups">
      <div key="center" className="multiverse-of-mixups-center">
        {" "}
        {props.children}
      </div>
      {Array.from(props.top).map((c, idx) => (
        <div className="multiverse-of-mixups-cell" key={`top-${idx}`}>
          {c.trim()}
        </div>
      ))}
      {Array.from(props.left).map((c, idx) => (
        <Fragment key={`middle-${idx}`}>
          <div className="multiverse-of-mixups-cell" key={`left-${idx}`}>
            {c.trim()}
          </div>
          <div className="multiverse-of-mixups-cell" key={`right-${idx}`}>
            {props.right.charAt(idx).trim()}
          </div>
        </Fragment>
      ))}
      {Array.from(props.bottom).map((c, idx) => (
        <div className="multiverse-of-mixups-cell" key={`bottom-${idx}`}>
          {c.trim()}
        </div>
      ))}
    </div>
  );
}
